import React from 'react'
import '../Projects/Projects.css'
import { Button } from '@mui/material'
import noodliee from './Assets/noodliee.PNG'
import textmodifier from './Assets/textmodifier.PNG'
import project3rd from './Assets/3rdproject.png'
import project4th from './Assets/4thproject.PNG'

export default function Projects() {
  return (
    // <div className="container">
    <>
      <h1 className='text-center py-5 project mt-5'>My Projects</h1>
    <div className="col-lg-12 mt-5 projects_container" id='projects'>
      
      <div className="row g-0">


        <div className="col-lg-6 px-0">
          <div className="image">
            <img src={noodliee} className="image_img " alt="" />
            <div className="image_overlay">
              <h5>WEBSITE</h5>
              <div className="image_title">Noodliee</div>
              <p className="image_description">
                React.js - Bootstrap
              </p>
              <Button variant="contained">

              <a href="https://noodliee.netlify.app/" target="_blank" rel="noreferrer">Live Demo</a>
              </Button>
              
            </div>
          </div>
        </div>
        <div className="col-lg-6 px-0">
          <div className="image">
            <img src={textmodifier} className="image_img " alt="" />
            <div className="image_overlay">
            <h5>WEBAPPLICATION</h5>
              <div className="image_title">TextModifier</div>
              <p className="image_description">
              React.js - Bootstrap
              </p>
              <Button variant="contained"><a href="https://qazizohaibali.github.io/TEXTMODIFIER/" target="_blank" rel="noreferrer">Live Demo</a></Button>
            </div>
          </div>
        </div>
        
        <div className="col-lg-6 px-0">
          <div className="image">
            <img src={project3rd} className="image_img " alt="" />
            <div className="image_overlay">
            <h5>COMPONENTS OF WEBSITE</h5>
              <div className="image_title">Electric-Bike</div>
              <p className="image_description">
              React.js - Tailwind
              </p>
              <Button variant="contained" disabled><a href="/">(In Porgress)</a></Button>
            </div>
          </div>
        </div>
        <div className="col-lg-6 px-0" >
          <div className="image">
            <img src={project4th} className="image_img " alt="" />
            <div className="image_overlay">
            <h5>ADMIN PANEL</h5>
              <div className="image_title">Internee-Dashboard</div>
              <p className="image_description">
              React.js - Material UI
              </p>
              <Button variant="contained" disabled> <a href="/">(In Porgress)</a></Button>
            </div>
          </div>
        </div>

      </div>  
    </div>


    </>

  )
}
